import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { EntityMaterialCategoryApi, FindOptions } from 'api';

export const filterEntityMaterialCategory = createAsyncThunk(
  'entityMaterialCategory/filterEntityMaterialCategory',
  async (option: FindOptions, { rejectWithValue }) => {
    try {
      const response = await EntityMaterialCategoryApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityMaterialCategoryForTableList = createAsyncThunk(
  'entityMaterialCategory/findEntityMaterialCategoryForTableList',
  async (option: FindOptions, { rejectWithValue }) => {
    try {
      const response = await EntityMaterialCategoryApi.findWithEntityForTable(
        option
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createEntityMaterialCategory = createAsyncThunk(
  'entityMaterialCategory/createEntityMaterialCategory',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityMaterialCategoryApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityMaterialCategoryWithEntity = createAsyncThunk(
  'entityMaterialCategory/findEntityMaterialCategoryWithEntity',
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await EntityMaterialCategoryApi.findWithEntity(params);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneEntityMaterialCategory = createAsyncThunk(
  'entityMaterialCategory/findOneEntityMaterialCategory',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id } = params;
      const response = await EntityMaterialCategoryApi.findOne(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityMaterialCategory = createAsyncThunk(
  'entityMaterialCategory/updateEntityMaterialCategory',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await EntityMaterialCategoryApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityMaterialCategoryStatus = createAsyncThunk(
  'entityMaterial/updateEntityMaterialStatus',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await EntityMaterialCategoryApi.updateStatus(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteEntityMaterialCategory = createAsyncThunk(
  'entityMaterialCategory/deleteEntityMaterialCategory',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityMaterialCategoryApi.delete(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface EntityMaterialCategoryState {
  tableList: Array<any>;
  isLoaded: boolean;
  savedList: Array<any>;
  reloadFlag: boolean;
  savedPagination: any;
  listAll: Array<any>;
}

const initialState: EntityMaterialCategoryState = {
  tableList: [],
  isLoaded: false,
  savedList: [],
  reloadFlag: false,
  savedPagination: { current: 1, next: 2, prev: 0, take: 10, total: 0 },
  listAll: [
    {
      key: 'all',
      value: 'all',
      name: 'Tất cả các danh mục',
    },
  ],
};

const entityMaterialCategorySlice = createSlice({
  name: 'entityMaterialCategory',
  initialState,
  reducers: {
    reloadEntityMaterialCategory(state) {
      state.reloadFlag = !state.reloadFlag;
    },
    updateSavedPaginationEntityMaterialCategory(state, action) {
      state.savedPagination = action.payload;
    },
    updateSavedListEntityMaterialCategory(state, action) {
      state.savedList = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(
      findEntityMaterialCategoryWithEntity.fulfilled,
      (state, action) => {
        const { data } = action.payload;
        const newData = (data || []).map((item: any) => {
          return {
            ...item,
            key: item.id,
            value: item.id,
            name: item.isDefault ? `${item.name} (Mặc định)` : item.name,
          };
        });

        state.listAll = [
          {
            key: 'all',
            value: 'all',
            name: 'Tất cả các danh mục',
            displayName: 'Tất cả các danh mục',
          },
          ...newData,
        ];
      }
    );
  },
});

const { actions, reducer: entityMaterialCategoryReducer } =
  entityMaterialCategorySlice;

export const {
  reloadEntityMaterialCategory,
  updateSavedPaginationEntityMaterialCategory,
  updateSavedListEntityMaterialCategory,
} = actions;

export default entityMaterialCategoryReducer;
